import { TranslateOrEmpty, TranslationParameterMapping } from '@teliaee/telia-translate';

export const DEFAULT_APP = 'diilweb';
export const GLOBAL_APP = 'globaldiil';

export const diilTranslateOrEmpty = (translateFunction: TranslateOrEmpty, key: string, params?: TranslationParameterMapping) => {
  return translateFunction(DEFAULT_APP, key, params);
};
